import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AllowedFileTypes } from '../../constants/file-upload-constants';
import { ConfirmationDialogService } from '../../services/dialogs/confirmation-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'av-file-input',
  templateUrl: './av-file-input.component.html',
  styleUrls: ['./av-file-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: AvFileInputComponent
    }
  ]
})
export class AvFileInputComponent implements OnInit, ControlValueAccessor {
  @Input() label: string = 'File';
  @Input() buttonText: string = 'Add File';
  @Input() allowedFiles: string[] = AllowedFileTypes;
  @Input() maxFileSize: number = 5;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  file: any;
  disabled: boolean = false;
  touched: boolean = false;
  onChange = (file) => {};
  onTouched = () => {};

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private translateService: TranslateService
  ) { }

  get files(): FileList {
    if (!this.fileInput)
      return this.file;
    return this.fileInput.nativeElement.files;
  }

  writeValue(file: any): void {
    this.file = file;
  }
  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  fileDisplay() {
    if (this.files?.length === 1) {
      return this.files[0].name;
    } else if (this.files?.length > 1) {
      return `${this.files[0].name} + ${this.files.length - 2}`;
    }
    return this.file;
  }

  onFileSelected() {
    this.markAsTouched();
    if (this.files[0].size > this.maxFileSize * 1024 * 1024) {
      this.removeFile();
      this.confirmationDialogService.openDialog({
        title: 'File Size Exceeded',
        message: this.translateService.instant('ERRORS.FILE_SIZE_EXCEEDED', {fileSize: `${this.maxFileSize} MB.`}),
        yes: 'GENERIC.OK'
      });
      return;
    }
    this.writeValue(this.files[0]);
    this.onChange(this.file);
  }

  openRemoveFileDialog() {
    this.confirmationDialogService.openDialog({
      message: 'MODALS.CONFIRMATION.DELETE_MESSAGE',
      yes: 'GENERIC.YES',
      no: 'GENERIC.NO'
    }).afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.removeFile();
      }
    });
  }

  removeFile() {
    this.markAsTouched();
    this.fileInput.nativeElement.value = '';
    this.writeValue(null);
    this.onChange(this.file);
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  ngOnInit(): void {
  }

}
